module.exports = __webpack_public_path__ + "img/0004.d72e54bf.png";